<template>
  <div class="apply">
    <h3>粉丝俱乐部有奖调查问卷</h3>
    <!-- <div class="active-title">{{ activeData && activeData.name }}</div> -->
    <div class="active-detail-wp">
      <div>粉丝俱乐部有奖调查问卷，感谢您的每一个宝贵建议与反馈。</div>
    </div>
    <div class="quest-wrap">
      <div class="quest-item" v-for="(item, index) in forms" :key="item.number">
        <div class="quest-title">{{ item.question }}</div>
        <van-radio-group v-model="answers[index].answer">
          <van-radio
            class="quest-item-option"
            v-for="item1 in item.answers"
            :key="item1"
            :name="item1"
            @click="questOptionClick(index, item1)"
            checked-color="#ee0a24"
            >{{ item1 }}</van-radio
          >
          <van-field
            v-if="item.answers.length == 0"
            autosize
            :border="true"
            v-model="answers[index].answer"
          />
        </van-radio-group>
      </div>
    </div>
    <div class="message">
      （内容丰富的粉丝朋友们有机会获得随机加增的一份产品呦~）
    </div>
    <div class="active-form">
      <van-form @submit="onSubmit">
        <van-field
          v-model="username"
          name="姓名"
          label="姓名"
          placeholder="姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          v-model="phone"
          type="number"
          name="手机号"
          label="手机号"
          placeholder="手机号"
          :rules="[{ required: true, message: '请填写手机号' }]"
        />
        <van-field
          v-model="address"
          name="地址"
          label="地址"
          placeholder="地址"
          :rules="[{ required: true, message: '请填写地址' }]"
        />

        <div style="margin: 16px">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            color="#D33A46"
            >提交</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import { eventid_detail, applay_eventid } from "network/home";
import { getUserInfo } from "network/profile";
import qs from "qs";
export default {
  name: "Apply",
  components: {},
  data() {
    return {
      activeData: {},
      forms: [
        {
          question: "1、您的年龄",
          number: "1",
          answers: ["10-19岁", "20-29岁", "30-39岁", "40-49岁", "50岁及以上"],
        },
        {
          question: "2、您的性别",
          number: "2",
          answers: ["男", "女"],
        },
        {
          question:
            "3、您平时在各种媒体上经常看什么方面的内容/喜欢看什么方面的内容",
          number: "3",
          answers: [
            "快手早餐",
            "热门流行料理",
            "低脂减肥餐",
            "营养健康科普知识",
            "儿童餐单/辅食制作",
            "甜点/下午茶",
            "下厨技巧/烹调方法",
          ],
        },
        {
          question: "4、您使用粉丝俱乐部的频率如何？",
          number: "4",
          answers: [
            "每周都来参与活动",
            "平均每月登录一次",
            "偶尔2-3个月会登录一次",
            "看到推文推送才会来看一眼",
            "首次登录后就没有再使用了",
            "暂时还没登录过",
          ],
        },
        {
          question: "5、什么原因让您没有经常登录，或让您觉得使用不便的？",
          number: "5",
          answers: [
            "挺好用的，很满意",
            "登录入口不好找",
            "页面使用不方便",
            "活动参与太复杂",
            "对活动或奖品不感性兴趣",
            "对粉丝发布的内容不感兴趣",
            "其他 ",
          ],
        },
        {
          question:
            "5-1、还请说明一下，选择【其他】的具体原因：（仅限选择第5题【其他】选项的人）",
          number: "5-1",
          answers: [],
        },
        {
          question:
            "6、下面哪项粉丝俱乐部的改善能更吸引你，让你会经常登录来玩?",
          number: "6",
          answers: [
            "每日签到红包奖励",
            "成长养成类签到游戏",
            "活动参与门槛降低",
            "更多更丰富的活动形式与机制",
            "粉丝发布更多原创内容",
            "其他 ",
          ],
        },
        {
          question:
            "6-1、请详细说明，你想到的【其他】改善意见：（仅限选择第6题【其他】选项的人）",
          number: "6-1",
          answers: [],
        },
        {
          question: "7、你最喜欢参加什么形式的互动活动？",
          number: "7",
          answers: [
            "食谱征集投稿分享食谱",
            "投票助威拿奖",
            "互动问答测试",
            "产品体验试用",
            "其他 ",
          ],
        },
        {
          question:
            "7-1、请举例说明，你想到的【其他】互动活动形式：（仅限选择第7题【其他】选项的人）",
          number: "7-1",
          answers: [],
        },
        {
          question: "8、您登录粉丝俱乐部后最常进行的操作是？",
          number: "8",
          answers: [
            "查看活动讯息",
            "签到",
            "浏览网友发布的内容",
            "发布自己的帖子",
            "进行积分兑换",
          ],
        },
        {
          question:
            "9、留言板（您有什么想对粉丝俱乐部说的话~或者您对俱乐部有什么建议和意见）",
          number: "9",
          answers: [],
        },
      ],
      answers: [], //提交数据
      username: "",
      phone: "",
      address: "",
      text: "",
      userInfo: "",
    };
  },
  computed: {},
  created() {
    //为了微信登录
    // this.getActiveDetail();
    getUserInfo().then((res) => {
      this.userInfo = res.data;
      localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
    });
    this.forms.forEach((item, index) => {
      let answer = { question: item.question, answer: "" };
      this.answers.push(answer);
    });
  },
  mounted() {},
  methods: {
    getActiveDetail() {
      eventid_detail(21).then((res) => {});
    },
    //选择问题
    questOptionClick(index, item1) {
      let item = this.answers[index];
      item.answer = item1;
    },
    //提交问题
    onSubmit() {
      for (var i in this.answers) {
        var item = this.answers[i];

        if (item.answer.length == 0) {
          if (
            item.question.search("5-1") != -1 ||
            item.question.search("6-1") != -1 ||
            item.question.search("7-1") != -1 ||
            item.question.search("9") != -1
          ) {
          } else {
            console.log(item.question);
            this.$toast("请回答全部问题");
            return;
          }
        }
      }
      if (this.username.length < 2) {
        this.$toast("姓名长度不合法");
        return;
      }
      if (this.address.length == 0) {
        this.$toast("请填写地址");
        return;
      }

      const regMobile =
        /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regMobile.test(this.phone)) {
        this.$toast("手机号格式错误");
        return;
      }
      const data = {
        event_id: this.$route.query.event_id,
        name: this.username,
        address: this.address,
        phone: this.phone,
        answers: this.answers,
      };
      applay_eventid(qs.stringify(data)).then((res) => {
        if (res.errors) {
          this.$toast(res.errors.name);
        } else {
          this.$dialog
            .alert({
              message:
                "调查问卷提交成功！请耐心等待开奖，关注粉丝俱乐部里的开奖公告。",
            })
            .then(() => {
              this.$router.push({ path: "/home" });
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.apply {
  background: #fff;
}
.apply h3 {
  margin: 0 0px;
  padding: 20px 15px;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
  color: #fff;
  background-color: var(--color-main);
}
.quest-wrap {
  padding: 15px;
}
.quest-title {
  font-size: 15px;
  color: #333333;
}
.quest-item {
  margin: 20px 0;
}
.quest-item-option {
  margin: 10px 0;
}
.active-title {
  margin-top: 15px;
  font-size: 17px;
  color: #333333;
  text-align: center;
}
.active-detail-wp {
  margin: 15px 10px 10px 10px;
  padding: 15px;
  border-radius: 15px;
  font-size: 13px;
  background-color: #f5f5f5;
  white-space: pre-line;
}
.active-form {
  margin-top: 30px;
}
.active-time {
  margin-top: 10px;
}
.message {
  font-size: 13px;
  color: rgb(222, 48, 48);
}
::v-deep .van-field {
  margin-top: 5px;
  background-color: #f5f5f5;
}
</style>